<cll-dialog-layout>
    <cll-dialog-header>
        <cll-icon cllDialogIcon>mark_email_read</cll-icon>
        <cll-dialog-title>
            Mark messages as read
        </cll-dialog-title>
        <cll-dialog-subtitle>{{messages.ids.length}} messages selected</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <span>Are you sure you want to mark these messages as read? This will clear any unread notifications.</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (readMessagesRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                (click)="read()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
